module.exports = __webpack_public_path__ + "static/img/airvisual.13bb433.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/airvisual.png
// module id = 272
// module chunks = 1